<template>
    <div class="vh-50 video-bg-container d-flex align-items-center">
        <video playsinline autoplay muted loop poster="https://d3ioifgscy1qpn.cloudfront.net/videos/general/footer_video.mov.65e79d1da7050.0000000.jpg">
            <source src="https://d3ioifgscy1qpn.cloudfront.net/videos/general/footer_video.mov.65e79d1da7050.mp4" type="video/mp4">
        </video>

        <div class="m-auto text-center">
            <h3 class="mb-4">{{ uiStore.footerCtaLabel }}</h3>

            <phone-cta :type="uiStore.footerCtaType" pageLocation="footer-video"/>
        </div>
    </div>
    
</template>

<script type="text/javascript">
    import PhoneCta from '@/components/Content/PhoneCta.vue';
    import CommonComponents from '@/components/Common.vue';

    import { UseUIStore } from '@/store/UI.js';

    export default {
        components: {
            PhoneCta,
            ...CommonComponents
        },

        setup() {
            return {
                uiStore: UseUIStore(),
            };
        },
    }
</script>